<template>
    <div>

        <div v-html="content"
             class="py-5"></div>

    </div>
</template>

<script>
import actionProvider from '@/mixins/actionProvider'

export default 
{
   name: 'ActionProviderPipelineCompleted',

   mixins: [ actionProvider ],

   components: 
   {

   },

   data: () => ({

   }),

   props: {
    content: {
        type: String,
        default: 'Fine.'
    }
   },

   computed: {},

   methods:
   {

   },

   mounted()
   {

   }
}
</script>